document.addEventListener('DOMContentLoaded', () => {
  const revealItems = [...document.querySelectorAll('.nvz-section, .nvz-offer, .nvz-guarantee, .nvz-mid-cta')];
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -40px' });
    revealItems.forEach((item) => {
      item.classList.add('nvz-reveal');
      observer.observe(item);
    });
  }

  document.querySelectorAll('[data-nvz-product]').forEach((root) => {
    const slides = [...root.querySelectorAll('[data-nvz-slide]')];
    const thumbs = [...root.querySelectorAll('[data-nvz-thumb]')];

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const id = thumb.dataset.mediaId;
        slides.forEach((slide) => slide.classList.toggle('is-active', slide.dataset.mediaId === id));
        thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      });
    });

    const variantSelect = root.querySelector('[data-nvz-variant]');
    const variantInput = root.querySelector('[data-nvz-variant-input]');
    const addButton = root.querySelector('[data-nvz-add]');
    const quantityInput = root.querySelector('[data-nvz-quantity-input]');
    const bundleButtons = [...root.querySelectorAll('[data-nvz-bundle]')];
    const stickyPrice = root.querySelector('.nvz-mobile-sticky strong');

    const selectBundle = (selected) => {
      if (!selected || selected.dataset.available !== 'true') return;
      bundleButtons.forEach((button) => {
        const active = button === selected;
        button.classList.toggle('is-selected', active);
        button.setAttribute('aria-pressed', String(active));
      });
      if (variantInput && selected.dataset.variantId) variantInput.value = selected.dataset.variantId;
      if (quantityInput) quantityInput.value = selected.dataset.quantity || '1';
      if (stickyPrice && selected.dataset.price) stickyPrice.textContent = selected.dataset.price;
      if (addButton) addButton.disabled = false;
    };

    if (variantSelect && variantInput) {
      variantSelect.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        root.querySelectorAll('[data-nvz-current-product]').forEach((button) => {
          button.dataset.variantId = option.value;
          button.dataset.available = option.dataset.available;
          button.classList.toggle('is-unavailable', option.dataset.available !== 'true');
          button.setAttribute('aria-disabled', String(option.dataset.available !== 'true'));
        });
        const selectedBundle = bundleButtons.find((button) => button.classList.contains('is-selected'));
        if (selectedBundle?.hasAttribute('data-nvz-current-product')) selectBundle(selectedBundle);
      });
    }

    bundleButtons.forEach((button) => button.addEventListener('click', () => {
      if (button.dataset.available !== 'true') return;
      selectBundle(button);
    }));
    if (bundleButtons.length) selectBundle(bundleButtons.find((button) => button.classList.contains('is-selected')) || bundleButtons[0]);

    root.querySelectorAll('[data-nvz-scroll-buy]').forEach((button) => {
      button.addEventListener('click', () => {
        root.querySelector('[data-nvz-offer]')?.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
    });
  });

  document.querySelectorAll('a[href="#NuvezzaProduct"]').forEach((link) => {
    link.addEventListener('click', (event) => {
      const target = document.querySelector('#NuvezzaProduct [data-nvz-offer]') || document.querySelector('#NuvezzaProduct');
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  });
});
